import { ref } from 'vue';

export function useCarouselDragPrevention(dragThreshold = 5) {
  const startX = ref(0);
  const startY = ref(0);
  const hasDragged = ref(false);
  const isClickable = ref(true);

  function startDrag(event) {
    const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
    const clientY = event.type.includes('touch') ? event.touches[0].clientY : event.clientY;
    startX.value = clientX;
    startY.value = clientY;
    hasDragged.value = false;
    isClickable.value = true;
  }

  function onDrag(event) {
    const clientX = event.type.includes('touch') ? event.touches[0].clientX : event.clientX;
    const clientY = event.type.includes('touch') ? event.touches[0].clientY : event.clientY;
    const deltaX = Math.abs(clientX - startX.value);
    const deltaY = Math.abs(clientY - startY.value);

    if (deltaX > dragThreshold || deltaY > dragThreshold) {
      hasDragged.value = true;
    }
  }

  function handleMouseUp(event, callback) {
    isClickable.value = false;

    if (!hasDragged.value && callback) {
      callback(event);
    }
  }

  function handleCardClick(event, callback) {
    if (isClickable.value && !hasDragged.value && callback) {
      callback(event);
    }
  }

  return {
    hasDragged,
    isClickable,
    startDrag,
    onDrag,
    handleMouseUp,
    handleCardClick,
  };
}
